module.exports = "/images/vendor/flag-icon-css/flags/4x3/ws.svg?405a2c5f036343f54f0e46ab054e7cf8";